export default "__VITE_ASSET__59f4a0e3__"